"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = exports.BusinessNominatedSuperInfoResponse = exports.BusinessSuperFundConfigurationResponse = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const ResponseBase_1 = require("../ResponseBase");
const handler_1 = require("../utils/handler");
const SuperFundResponse_1 = require("../utils/SuperFundResponse");
const Get_1 = require("./models/Get");
const Register_1 = require("./models/Register");
const Update_1 = require("./models/Update");
class BusinessSuperFundConfigurationResponse extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsIn)(['SUPER_API', 'MANUAL']),
    (0, tslib_1.__metadata)("design:type", String)
], BusinessSuperFundConfigurationResponse.prototype, "provider", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], BusinessSuperFundConfigurationResponse.prototype, "missingABN", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], BusinessSuperFundConfigurationResponse.prototype, "superAPIConfigurationEmbedURL", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, tslib_1.__metadata)("design:type", String)
], BusinessSuperFundConfigurationResponse.prototype, "superAPIATOConfigurationEmbedURL", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], BusinessSuperFundConfigurationResponse.prototype, "isStaplingEnabled", void 0);
exports.BusinessSuperFundConfigurationResponse = BusinessSuperFundConfigurationResponse;
class BusinessNominatedSuperInfoResponse extends ResponseBase_1.ResponseBase {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: SuperFundResponse_1.SuperFundResponse }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInstance)(SuperFundResponse_1.SuperFundResponse),
    (0, tslib_1.__metadata)("design:type", SuperFundResponse_1.SuperFundResponse)
], BusinessNominatedSuperInfoResponse.prototype, "fund", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: BusinessSuperFundConfigurationResponse }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInstance)(BusinessSuperFundConfigurationResponse),
    (0, tslib_1.__metadata)("design:type", BusinessSuperFundConfigurationResponse)
], BusinessNominatedSuperInfoResponse.prototype, "configuration", void 0);
exports.BusinessNominatedSuperInfoResponse = BusinessNominatedSuperInfoResponse;
class Client {
    constructor(http, $error) {
        this.http = http;
        this.$error = $error;
        this.register = (0, handler_1.handler)(this, async (data) => await this.http
            .request()
            .to('business')
            .bodyJSON(Register_1.Register.Request.create(data))
            .post((data) => Register_1.Register.Response.fromJSON(data)));
        this.updateMyBusiness = (0, handler_1.handler)(this, async (data) => await this.http
            .request()
            .to(`business/my`)
            .bodyJSON(Update_1.Update.Request.create(data))
            .post());
        this.get = (0, handler_1.handler)(this, async (businessId) => await this.http
            .request()
            .to(`business/${businessId}`)
            .get((data) => Get_1.Get.Business.Response.fromJSON(data)));
        this.getBusinessNominatedSuper = (0, handler_1.handler)(this, async (businessId) => this.http
            .request()
            .to(`/business/${businessId}/nominated-super-fund`)
            .get((data) => BusinessNominatedSuperInfoResponse.create(data)));
        this.updateBusinessNominatedSuper = (0, handler_1.handler)(this, async (data) => this.http
            .request()
            .to(`/business/nominated-super-fund`)
            .bodyJSON(Update_1.Update.NominatedSuper.Request.create(data))
            .post());
        this.deleteMyBusiness = (0, handler_1.handler)(this, async (businessId) => this.http.request().to(`/business/${businessId}`).delete());
    }
}
exports.Client = Client;
